import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10A10 10 0 0010 0zm0 18a8 8 0 110-16 8 8 0 010 16zm.153-13.861A.5.5 0 0110.53 4l.04.02a6 6 0 014 9.86.5.5 0 01-.73 0L10 10.03V4.51a.5.5 0 01.153-.371z" fill="#696E7C" /></svg>);